var _excluded = ["isRegionAgnostic"];
function _objectWithoutProperties(source, excluded) { if (source == null)
    return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0)
            continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key))
            continue;
        target[key] = source[key];
    }
} return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
import { useRegion } from 'shared/components/RegionSwitcher/RegionProvider';
import { makeUseAxiosQuery } from '@nordvpn/teams.core/lib/hooks/react-query/useAxiosQuery';
import { defaultOptions } from './reactQuery';
import { joinKeys } from './utils';
var useBaseAxiosQuery = makeUseAxiosQuery(defaultOptions);
/**
 * Queries are cached per region, so the same key never serves data from two data centres.
 *
 * Set `isRegionAgnostic` on queries whose endpoint is listed in `REGION_AGNOSTIC_PATHS`
 * (`./regionHeader`) - those return the same data in every region, so scoping their key by
 * region only splits the cache and refetches for nothing.
 *
 * Nothing enforces this: unlike `useRQListApi`, this hook only receives the query function, so
 * it cannot tell which endpoint is being called. Keep the flag and that list in sync by hand.
 */
export var useAxiosQuery = function useAxiosQuery(key, queryFunction) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var isRegionAgnostic = config.isRegionAgnostic, queryConfig = _objectWithoutProperties(config, _excluded);
    var region = useRegion();
    return useBaseAxiosQuery(isRegionAgnostic ? key : joinKeys(key, "region=".concat(region)), queryFunction, queryConfig);
};
